export const nbRows = ref(10);
export const nbPage = ref(1);
export const sortOrder = ref(null);
export const sortField = ref(null);

function valueFromMatchMode (value, matchMode) {
  if (matchMode.includes('date')) {
    return new Date(value);
  }

  if (matchMode === 'in') {
    return value.split(',');
  }

  return value;
}

export function setupDataTableConfigFromUrl (filters, route) {
  // example: http://localhost:3000/opportunities?filters[id][startsWith][]=1&filters[reqId][notContains][]=9&filters[reqId][contains][]=51&sortField=id&sortOrder=1&nbRows=50
  // Get qry params from url to update datatable filters/sort
  const urlQryObject = parseUrlParams(route.fullPath);
  if (Object.entries(urlQryObject).length) {
    for (const [key, value] of Object.entries(urlQryObject)) {
      if (key === 'sortField') { sortField.value = value; }
      if (key === 'sortOrder') { sortOrder.value = Number.parseInt(value); }
      if (key === 'limit') { nbRows.value = Number.parseInt(value); }
      if (key === 'filters') {
        for (const [fKey, fValue] of Object.entries(urlQryObject.filters)) {
          Object.entries(fValue).forEach((entry, index) => {
            const [matchMode, rawValue] = entry;
            let normalizedValue = rawValue;
            if (Array.isArray(rawValue)) {
              normalizedValue = rawValue.map(v =>
                v === 'true' ? true : v === 'false' ? false : v,
              );
            } else {
              normalizedValue = rawValue === 'true'
                ? true
                : rawValue === 'false'
                  ? false
                  : rawValue;
            }
            const newValue = valueFromMatchMode(normalizedValue, matchMode);

            // Ensure filter entry and constraints array
            if (!filters.value[fKey] || !filters.value[fKey].constraints) {
              filters.value[fKey] = {
                operator: 'and',
                constraints: [],
              };
            }

            filters.value[fKey].constraints[index] = {
              value: newValue,
              matchMode,
            };
          });
        }
      }
    }
  }
}

export function parseUrlParams (url) {
  const params = new URLSearchParams(url?.split('?')[1]);
  const obj = {};
  for (const [key, value] of params.entries()) {
    const keys = key.split(/[[\]|]/).filter(k => k !== '');
    const lastKey = keys.pop();
    let currentObj = obj;
    for (const k of keys) {
      currentObj[k] = currentObj[k] || {};
      currentObj = currentObj[k];
    }
    if (lastKey.endsWith(']')) {
      const arrayKey = lastKey.slice(0, -1);
      currentObj[arrayKey] = currentObj[arrayKey] || [];
      currentObj[arrayKey].push(value);
    } else {
      currentObj[lastKey] = value;
    }
  }
  return obj;
}

export function filter (e, route, router, filters) {
  if (Object.values(e.filters).length) {
    const qry = {};
    Object.entries(e.filters).forEach((f) => {
      const key = f[0];
      const fvalue = f[1];
      fvalue.constraints.forEach((c, id) => {
        const valArr = [];
        qry[`filters[${key}][${c.matchMode}][]`] ??= [];
        if (c.value) {
          // If is date, format
          if (c.matchMode.includes('date')) {
            const date = new Date(c.value);
            const offset = date.getTimezoneOffset() / 60;
            date.setTime(date.getTime() - offset * 3600 * 1000);
            valArr.push(date.toISOString());
            qry[`filters[${key}][${c.matchMode}][]`].push(valArr);
            // eslint-disable-next-line no-param-reassign
            filters[key].constraints[id].value = date;
          } else {
            // If same filter, multiple values
            valArr.push(c.value);
            qry[`filters[${key}][${c.matchMode}][]`].push(valArr);
          }
        } else {
          // If filter doesn't exist anymore
          Object.entries(route.query).forEach((keyQ) => {
            if (keyQ[0].includes(key) && keyQ[0].includes(c.matchMode)) {
              delete qry[`filters[${key}][${c.matchMode}][]`];
            }
          });
        }
      });
    });
    router.replace({ query: qry });
  }
}

export function sort (e, route, router) {
  router.replace({ query: { ...route.query, sortField: e.sortField ? e.sortField : undefined, sortOrder: e.sortOrder ? e.sortOrder : undefined } });
}

export function onPage (e, route, router) {
  router.replace({ query: { ...route.query, limit: e.rows, page: e.page + 1 } });
}
